import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import moment from 'moment';
import UiComponent from '../UiComponent';
import {getCurrentTimeZone} from "../../utils/date";

export default class SimpleDatePicker extends UiComponent {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(value) {
    const field = this.props.field;
    let mVal = moment.utc(value, field.dateFormat, true);
    const isValid = mVal.isValid();
    field.value = isValid ? mVal._d : value;
    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange([
          this.props.relatedTo,
          field.name,
        ],
        field
      );
    } else {
      this.props.onChange(field.name, field);
    }
  }

  render() {
    const field = this.props.field || {};
    const containerClass = `form-group ${this.props.className}`;
    const inputProps = {
      disabled: this.props.disabled,
      placeholder: field.placeholder
    };

    return (
      <div className={containerClass}>
        {this.getLabel()}
        <Datetime
          value={
            field.value ? new Date( moment.tz(field.value, moment.tz.guess()).unix() * 1000) : ""
          }
          dateFormat={field.dateFormat}
          timeFormat={false}
          open={field.open}
          input={field.input}
          viewMode={field.viewMode}
          onChange={this.changeValue}
          onBlur={this.changeValue}
          inputProps={inputProps}
          utc={false}
          displayTimeZone={getCurrentTimeZone()}
        />
        {this.getErrors()}
      </div>
    );
  }
}

SimpleDatePicker.propTypes = {
  className: PropTypes.string,
  field: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/SimpleDatePicker/index.js